import React, { useRef } from "react";
import { Input } from "antd";
import type { InputRef, SearchProps } from "antd/es/input";
import useVisibilityFocus from "../../hooks/useVisibilityFocus";

const FilterSearchInput = (props: SearchProps) => {
  const inputRef = useRef<InputRef>(null);

  useVisibilityFocus(
    () => inputRef.current?.input,
    () => inputRef.current?.focus(),
  );

  return <Input.Search ref={inputRef} {...props} />;
};

export default FilterSearchInput;
